import {combineReducers} from 'redux';

import {SelectionSliceFor} from '../../../store/SelectionSliceFor';

const entityKey = 'application-screenshots';

const selectionSlice = SelectionSliceFor(entityKey);

export const {
    addToSelection,
    removeFromSelection,
    clearSelection,
} = selectionSlice.actions;

export const ApplicationScreenshotsReducer = combineReducers({
    selection: selectionSlice.reducer,
});
